// src/services/logRetryService.js
import { store } from "../redux/store";
import { sendLog, removePendingLog } from "../redux/features/loggerSlice";

class LogRetryService {
  constructor() {
    this.intervalId = null;
    this.maxRetries = 5;
    this.retryInterval = 30000; // 30 segundos
  }

  start() {
    if (this.intervalId) return;

    this.intervalId = setInterval(() => {
      this.retryPendingLogs();
    }, this.retryInterval);

    if (process.env.NODE_ENV === "development") {
      console.log("🔄 Log retry service started");
    }
  }

  stop() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  async retryPendingLogs() {
    // No reintentar en desarrollo
    if (process.env.NODE_ENV === "development") {
      return;
    }

    const state = store.getState();
    const { pendingLogs, logs } = state.logger;

    if (pendingLogs.length === 0) return;

    console.log(`🔄 Reintentando ${pendingLogs.length} logs pendientes...`);

    for (const log of pendingLogs) {
      try {
        // Verificar si ya se ha intentado demasiadas veces
        const uiLog = logs.find((l) => l.id === log.id);
        if (uiLog && (uiLog.retryCount || 0) >= this.maxRetries) {
          store.dispatch(removePendingLog(log.id));
          continue;
        }

        await store.dispatch(sendLog(log)).unwrap();
      } catch (error) {
        console.warn("Failed to retry log:", error);
        break;
      }

      // Pequeña pausa entre logs para no saturar
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
  }
}

export const logRetryService = new LogRetryService();
